import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalFloristIcon from "@mui/icons-material/LocalFlorist"

export default function BigSideMenuCard({
  name = "Nome terreno",
  crop = "-",
  cropLabel = "Coltura",
  area = 3.2873823983493,
  iconColor = "green",
  onClick,
  open = false,
}) {
  var areaDisplay = area.toFixed(4);

  return (
    <Card
      variant="outlined"
      sx={{
        flex: 1,
        m: 1,
        p: 1,
        backgroundColor: "background.tertiary",
        minHeight: "100px", // ensure a reasonable minimum size
        maxHeight: "150px", // ensure a reasonable maximum size
      }}
      onClick={onClick}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "row",
          alignContent: "space-between",
          flexGrow: 1,
        }}
      >
        <Box flexDirection="column">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignContent: "flex-start",
              justifyContent: "center",
            }}
          >
            <LocalFloristIcon
              fontSize="medium"
              sx={{ color: iconColor, alignSelf: "center", mr: 1, ml: 0 }}
            />
            <Typography fontSize="base" fontWeight="medium">
              {name}
            </Typography>
          </Box>
          <Typography fontSize="14px" sx={{ mt: 1, color: "text.secondary" }}>
            {cropLabel}: {crop}
          </Typography>
          <Typography fontSize="14px" sx={{ mb: 1, color: "text.secondary" }}>
            Superficie: {areaDisplay} km²
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            mt: 1,
          }}
        >
          {open ? (
            <ExpandMoreIcon fontSize="small" />
          ) : (
            <ChevronRightIcon fontSize="small" />
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
